import { createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { RenewalsRepository } from '~/repositories/renewalsRepository';
import type { NewLeaseRenewalOfferListItem } from '~/contexts/leases/LeasesRenewalsContext';
import type { LeasesRenewalsFilter } from '~/repositories/leasesRenewalsRepository';
import type { LeaseDto, LeaseRenewalOfferItemDto, PropertyDto, UnitDto } from '~/swagger/portal/Api';

const repo = new RenewalsRepository();

type Filter = LeasesRenewalsFilter;

export const [RenewalsProvider, useRenewals] = createMagicDoorContext('Renewals', () => {
  const [leasesRenewals, getLeasesRenewals, leasesRenewalsActions] = createTriggerResource(async (params: Filter) => {
    const response = await repo.getRenewalOffers({
      page: params.page ?? 1,
      pageSize: params.pageSize ?? 100,
      statuses: params.statuses,
    });
    return {
      ...response,
      items: response.items.map((item: LeaseRenewalOfferItemDto) => ({
        ...item,
        chartOfAccounts: response.chartOfAccounts,
        leases: response.leases,
        lease: response.leases.find((lease: LeaseDto) => lease.id === item.leaseId),
        property: response.properties.find((property: PropertyDto) => property.id === item.propertyId),
        unit: response.units.find((unit: UnitDto) => unit.id === item.unitId),
      })) as NewLeaseRenewalOfferListItem[],
    };
  });

  return {
    leasesRenewals,
    getLeasesRenewals,
    leasesRenewalsActions,
  };
});
